export const ADD_INGERDIENT ='ADD_INGERDIENT';
export const REMOVE_INGERDIENT ='REMOVE_INGERDIENT';
export const SET_INGERDIENTS = 'SET_INGERDIENTS';
export const FETCH_INGERDIENTS_FAILED ='FETCH_INGERDIENTS_FAILED';

export const PURCHASE_BURGER_SUCCESS = 'PURCHASE_BURGER_SUCCESS';
export const PURCHASE_BURGER_FAIL = 'PURCHASE_BURGER_FAIL';
export const PURCHASE_BURGER_START = 'PURCHASE_BURGER_START';
export const PURCHASE_INIT = 'PURCHASE_INIT';

export const FETCH_ORDER_SUCCESS = 'FETCH_ORDER_SUCCESS';
export const FETCH_ORDER_FAIL = 'FETCH_ORDER_FAIL';
export const FETCH_ORDER_START = 'FETCH_ORDER_START';

export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';

